import { render, staticRenderFns } from "./VueRadioButton.vue?vue&type=template&id=125652e3&scoped=true&"
import script from "./VueRadioButton.vue?vue&type=script&lang=js&"
export * from "./VueRadioButton.vue?vue&type=script&lang=js&"
import style0 from "./VueRadioButton.vue?vue&type=style&index=0&id=125652e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125652e3",
  null
  
)

export default component.exports